import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { ENDING_COMMENT, ENDING_TITLE } from '@constants/text';

function End(): ReactElement {
  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{ENDING_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={7.5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col style={{}} yzTypeCol="center">
          <TypographyText style={{ whiteSpace: 'pre-wrap' }} yzTypeTypographyText="basic">
            {ENDING_COMMENT}
          </TypographyText>
        </Col>
      </Row>
      <Divider margin={7.5} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <img alt="end-img" src={`${process.env.PUBLIC_URL}/img/end-img.webp`} width="168px" />
        </Col>
      </Row>
    </Layout>
  );
}

export default End;
